export enum StatusAtendimento {
  AGENDADO = 'AGENDADO',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  CONCLUIDO = 'CONCLUIDO',
  CANCELADO = 'CANCELADO',
  REAGENDADO = 'REAGENDADO'
}

export interface Atendimento {
  id: number
  id_paciente: number
  id_medico?: number
  id_tipo_atendimento?: number
  data_atendimento: string
  data_fim?: string
  status_atendimento: StatusAtendimento
  motivo_atendimento?: string
  observacoes?: string
  protocolo?: string
  valor_atendimento?: number
  local_atendimento?: string
  paciente?: {
    id: number
    pessoa: {
      id: number
      nome: string
      data_nascimento?: string
      genero?: string
    }
  }
  medico?: {
    id: number
    pessoa: {
      id: number
      nome: string
    }
  }
  tipoAtendimento?: {
    id: number
    nome: string
    descricao?: string
  }
}

export interface AtendimentoResponse {
  result: Atendimento[]
}

export type DocumentStatus = 'completed' | 'pending' | 'not_started'

export interface Document {
  id: string
  name: string
  category: string
  status: DocumentStatus
  lastEdit?: string
  fields?: Record<string, string>
  attachments?: Array<{ id: string; name: string; type: string; url: string }>
}

export interface TimelineStep {
  id: string
  title: string
  status: DocumentStatus
  icon: any
  doctor?: string
  date?: string
}

export interface Patient {
  id: number
  pessoa: {
    nome: string
    data_nascimento?: string
    telefones?: Array<{
      telefone: string
      tipo: string
    }>
    pessoaFisica?: {
      cpf: string
    }
  }
  convenios?: Array<{
    nome: string
  }>
}

export interface PaginationInfo {
  page: number
  limit: number
  total: number
  totalPages: number
  hasNext: boolean
  hasPrev: boolean
}

export interface ApiResponse {
  data: Patient[]
  pagination: PaginationInfo
}

export interface Doctor {
  id: number
  pessoa: {
    nome: string
  }
  especialidade: {
    nome: string
  }
  crm?: string
  uf_crm?: string
}

export interface TipoAtendimento {
  id: number
  nome: string
  descricao?: string
  categoria?: string
}

export interface ListarPacienteProps {
  isOpen: boolean
  onClose: () => void
  onSelectPatient: (patient: any, doctor: Doctor, tipoAtendimento?: TipoAtendimento | null) => void
}
